import axios from "axios";
import { encryptStringWithPublicKey } from "../utils/data_encryption";
import permission from "../constant/permission_list";

export const API_ERROR = "API_ERROR";
export const RESET_API_ERROR = "RESET_API_ERROR";
export const UPDATE_API_ERROR = "UPDATE_API_ERROR";
export const GET_CLAIM_OPTIONS_SUCCESS = "GET_CLAIM_OPTIONS_SUCCESS";
export const GET_CLAIM_OPTIONS_ERROR = "GET_CLAIM_OPTIONS_ERROR";
export const GET_APP_CFG_PUBLIC_KEY_SUCCESS = "GET_APP_CFG_PUBLIC_KEY_SUCCESS";
export const DO_RELOGIN_BROKER_SUCCESS = "DO_RELOGIN_BROKER_SUCCESS";
export const DO_RELOGIN_HR_SUCCESS = "DO_RELOGIN_HR_SUCCESS";
export const DO_RELOGIN_ERROR = "DO_RELOGIN_ERROR";
export const DO_LOGIN_ERROR = "DO_LOGIN_ERROR";
export const DO_LOGIN_BROKER_SUCCESS = "DO_LOGIN_BROKER_SUCCESS";
export const DO_LOGIN_HR_SUCCESS = "DO_LOGIN_HR_SUCCESS";
export const SUBMIT_REQ_RESET_PASSWORD_ERROR =
  "SUBMIT_REQ_RESET_PASSWORD_ERROR";
export const SUBMIT_REQ_RESET_PASSWORD_SUCCESS =
  "SUBMIT_REQ_RESET_PASSWORD_SUCCESS";
export const SUBMIT_RESET_PASSWORD_SUCCESS = "SUBMIT_RESET_PASSWORD_SUCCESS";
export const SUBMIT_RESET_PASSWORD_ERROR = "SUBMIT_RESET_PASSWORD_ERROR";
export const SUBMIT_CREATE_PASSWORD_SUCCESS = "SUBMIT_CREATE_PASSWORD_SUCCESS";
export const SUBMIT_CREATE_PASSWORD_ERROR = "SUBMIT_CREATE_PASSWORD_ERROR";
export const GENERATE_LOGIN_EMAIL_OTP_SUCCESS =
  "GENERATE_LOGIN_EMAIL_OTP_SUCCESS";
export const GENERATE_LOGIN_EMAIL_OTP_ERROR = "GENERATE_LOGIN_EMAIL_OTP_ERROR";
export const VERIFY_LOGIN_EMAIL_OTP_SUCCESS = "VERIFY_LOGIN_EMAIL_OTP_SUCCESS";
export const VERIFY_LOGIN_EMAIL_OTP_ERROR = "VERIFY_LOGIN_EMAIL_OTP_ERROR";
export const RE_LOGIN_BROKER_SUCCESS = "RE_LOGIN_BROKER_SUCCESS";
export const RE_LOGIN_HR_SUCCESS = "RE_LOGIN_HR_SUCCESS";
export const LOGIN_BROKER_SUCCESS = "LOGIN_BROKER_SUCCESS";
export const LOGIN_HR_SUCCESS = "LOGIN_HR_SUCCESS";
export const UPDATE_USER_TOKEN_EXPIRED_ERROR =
  "UPDATE_USER_TOKEN_EXPIRED_ERROR";
export const GET_EMPLOYEE_LIST_SUCCESS = "GET_EMPLOYEE_LIST_SUCCESS";
export const GET_BROKER_LIST_SUCCESS = "GET_BROKER_LIST_SUCCESS";
export const GET_EMPLOYEE_LIST_BY_POLICY_SUCCESS =
  "GET_EMPLOYEE_LIST_BY_POLICY_SUCCESS";
export const GET_EMPLOYEE_CLAIMS_LIST_SUCCESS =
  "GET_EMPLOYEE_CLAIMS_LIST_SUCCESS";
export const GET_EMPLOYEE_CLAIMS_LIST_FAIL = "GET_EMPLOYEE_CLAIMS_LIST_FAIL";
export const GET_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS =
  "GET_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS";
export const GET_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS =
  "GET_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS";
export const GET_EMPLOYEE_PANEL_VISIT_CLAIM_DATA_SUCCESS =
  "GET_EMPLOYEE_PANEL_VISIT_CLAIM_DATA_SUCCESS";
export const GET_LAZY_EMPLOYEE_CLAIM_LIST_SUCCESS =
  "GET_LAZY_EMPLOYEE_CLAIM_LIST_SUCCESS";
export const GET_LAZY_EMPLOYEE_CLAIM_LIST_FAIL =
  "GET_LAZY_EMPLOYEE_CLAIM_LIST_FAIL";
export const SUBMIT_EMPLOYEE_UPDATE_ACCESS_SUCCESS =
  "SUBMIT_EMPLOYEE_UPDATE_ACCESS_SUCCESS";
export const SUBMIT_EMPLOYEE_HR_CLAIM_DATA_SUCCESS =
  "SUBMIT_EMPLOYEE_HR_CLAIM_DATA_SUCCESS";
export const GET_ALL_EMPLOYEE_CLAIMS_LIST_SUCCESS =
  "GET_ALL_EMPLOYEE_CLAIMS_LIST_SUCCESS";
export const GET_ALL_EMPLOYEE_CLAIMS_LIST_FAIL =
  "GET_ALL_EMPLOYEE_CLAIMS_LIST_FAIL";
export const GET_COMPANY_LIST_SUCCESS = "GET_COMPANY_LIST_SUCCESS";
export const VALIDATE_VIEW_ANALYTICS_PERMISSION =
  "VALIDATE_VIEW_ANALYTICS_PERMISSION";
export const VALIDATE_VIEW_PRE_SIGNED_ELOG_PERMISSION =
  "VALIDATE_VIEW_PRE_SIGNED_ELOG_PERMISSION";
export const VALIDATE_ADD_PARTNER_HR_PERMISSION =
  "VALIDATE_ADD_PARTNER_HR_PERMISSION";
export const VALIDATE_VIEW_HR_PARTNER_ACCOUNT_LIST_PERMISSION =
  "VALIDATE_VIEW_HR_PARTNER_ACCOUNT_LIST_PERMISSION";
export const VALIDATE_VIEW_ACCOUNT_LOGS_PERMISSION =
  "VALIDATE_VIEW_ACCOUNT_LOGS_PERMISSION";
export const VALIDATE_DOWNLOAD_CLAIMS_DATA_PERMISSION =
  "VALIDATE_DOWNLOAD_CLAIMS_DATA_PERMISSION";
export const UPDATE_BROKER_SELECTED_COMPANY_SUCCESS =
  "UPDATE_BROKER_SELECTED_COMPANY_SUCCESS";
export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS";
export const GET_INSIGHTS_URL_SUCCESS = "GET_INSIGHTS_URL_SUCCESS";
export const GET_PRE_SIGNED_ELOG_CONFIG_SUCCESS =
  "GET_PRE_SIGNED_ELOG_CONFIG_SUCCESS";
export const GET_PRE_SIGNED_ELOG_CONFIG_FAIL =
  "GET_PRE_SIGNED_ELOG_CONFIG_FAIL";
export const GET_EXPORT_EMPLOYEE_LIST_SUCCESS =
  "GET_EXPORT_EMPLOYEE_LIST_SUCCESS";
export const POST_PRE_SIGNED_ELOG_EMAIL_NOTIFICATION_SUCCESS =
  "POST_PRE_SIGNED_ELOG_EMAIL_NOTIFICATION_SUCCESS";
export const POST_PRE_SIGNED_ELOG_EMAIL_NOTIFICATION_FAIL =
  "POST_PRE_SIGNED_ELOG_EMAIL_NOTIFICATION_FAIL";
export const SUBMIT_PRE_SIGNED_ELOG_SUCCESS = "SUBMIT_PRE_SIGNED_ELOG_SUCCESS";
export const SUBMIT_PRE_SIGNED_ELOG_LIST_FAIL =
  "SUBMIT_PRE_SIGNED_ELOG_LIST_FAIL";
export const GET_PRE_SIGNED_ELOG_LIST_SUCCESS =
  "GET_PRE_SIGNED_ELOG_LIST_SUCCESS";
export const GET_PRE_SIGNED_ELOG_LIST_FAIL = "GET_PRE_SIGNED_ELOG_LIST_FAIL";
export const GET_ELOG_LIST_SUCCESS = "GET_ELOG_LIST_SUCCESS";
export const GET_ELOG_LIST_FAIL = "GET_ELOG_LIST_FAIL";
export const GET_FILES_URL_SUCCESS = "GET_FILES_URL_SUCCESS";
export const APPROVE_REJECT_ELOG_SUCCESS = "APPROVE_REJECT_ELOG_SUCCESS";
export const UPDATE_BROKER_SELECTED_POLICY_NO =
  "UPDATE_BROKER_SELECTED_POLICY_NO";
export const GET_HR_POLICY_NO_SUCCESS = "GET_HR_POLICY_NO_SUCCESS";
export const GET_BROKER_SINGLE_HR_COMPANY_SUCCESS =
  "GET_BROKER_SINGLE_HR_COMPANY_SUCCESS";
export const GET_BROKER_SINGLE_HR_COMPANY_FAIL =
  "GET_BROKER_SINGLE_HR_COMPANY_FAIL";
export const GET_HR_POLICY_NO_FAIL = "GET_HR_POLICY_NO_FAIL";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";
export const GET_APP_CFG_ELOG_QUESTIONS_SUCCESS =
  "GET_APP_CFG_ELOG_QUESTIONS_SUCCESS";
export const GET_APP_CFG_ELOG_QUESTIONS_ERROR =
  "GET_APP_CFG_ELOG_QUESTIONS_ERROR";
export const SUBMIT_ELOG_SUCCESS = "SUBMIT_ELOG_SUCCESS";
export const SUBMIT_ELOG_ERROR = "SUBMIT_ELOG_ERROR";
export const GET_CLINIC_LIST_SUCCESS = "GET_CLINIC_LIST_SUCCESS";
export const GET_CLINIC_LIST_ERROR = "GET_CLINIC_LIST_ERROR";
export const SUBMIT_CONTACT_US_SUCCESS = "SUBMIT_CONTACT_US_SUCCESS";
export const SUBMIT_CONTACT_US_FAIL = "SUBMIT_CONTACT_US_FAIL";
export const GET_ALERT_POP_UP_SUCCESS = "GET_ALERT_POP_UP_SUCCESS";
export const GET_ALERT_POP_UP_ERROR = "GET_ALERT_POP_UP_ERROR";
export const ADD_PARTNER_HR_SUCCESS = "ADD_PARTNER_HR_SUCCESS";
export const ADD_PARTNER_HR_ERROR = "ADD_PARTNER_HR_ERROR";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAIL = "GET_COMPANY_FAIL";
export const GET_MINSIGHT_CLAIM_REPORT_SUCCESS =
  "GET_MINSIGHT_CLAIM_REPORT_SUCCESS";
export const GET_MINSIGHT_CLAIM_REPORT_FAIL = "GET_MINSIGHT_CLAIM_REPORT_FAIL";
export const RESET_HR_CLAIM_DATA = "RESET_HR_CLAIM_DATA";
export const UPDATE_OUTPATIENT_CLAIM_SUCCESS =
  "UPDATE_OUTPATIENT_CLAIM_SUCCESS";
export const UPDATE_OUTPATIENT_CLAIM_ERROR = "UPDATE_OUTPATIENT_CLAIM_ERROR";
export const UPDATE_INPATIENT_CLAIM_SUCCESS = "UPDATE_INPATIENT_CLAIM_SUCCESS";
export const UPDATE_INPATIENT_CLAIM_ERROR = "UPDATE_INPATIENT_CLAIM_ERROR";
export const TRIGGER_ONBOARDING_EMAIL_SUCCESS =
  "TRIGGER_ONBOARDING_EMAIL_SUCCESS";
export const TRIGGER_ONBOARDING_EMAIL_FAIL = "TRIGGER_ONBOARDING_EMAIL_FAIL";
export const TRIGGER_RESET_PASSWORD_EMAIL_SUCCESS =
  "TRIGGER_RESET_PASSWORD_EMAIL_SUCCESS";
export const TRIGGER_RESET_PASSWORD_EMAIL_FAIL =
  "TRIGGER_RESET_PASSWORD_EMAIL_FAIL";
export const GET_BANK_LIST_SUCCESS = "GET_BANK_LIST_SUCCESS";
export const GET_BANK_LIST_FAILED = "GET_BANK_LIST_FAILED";

const ROOT_URL = process.env.REACT_APP_API_ROOT_URL;
const ENABLE_OTP = process.env.REACT_APP_ENABLE_OTP;
const MINSIGHT_URL = process.env.REACT_APP_MINSIGHT_API_URL;
// const INSURER_PORTAL = process.env.REACT_APP_INSURER_PORTAL;
// const axiosCancelToken = axios.CancelToken;
// const sourcer = axiosCancelToken.source();

const INSURER_PORTAL =
  window &&
  window.location &&
  window.location.hostname &&
  window.location.hostname.startsWith("insurer")
    ? "1"
    : "0";

// Add a response interceptor to axios to return the errorMessage from API instead of error object
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      // console.log("err0r-data", error.response.data);
      return Promise.reject({
        errorCode: 401,
        errorMessage: "Unauthorized Access or Token has Expired",
      });
    } else {
      if (error.response) {
        return Promise.reject({
          errorCode: error.response.status,
          errorMessage:
            error.response.data && error.response.data.errorMessage
              ? error.response.data.errorMessage
              : "Something went wrong.",
        });
      } else {
        return Promise.reject({
          errorCode: error.response.status,
          errorMessage: error,
        });
      }
    }
  }
);

export function resetAPIError() {
  return {
    type: resetAPIError,
    payload: {
      error: null,
    },
  };
}

export function getPublicKey() {
  const url = `${ROOT_URL}/publickey`;

  const request = axios.get(url);
  return {
    type: GET_APP_CFG_PUBLIC_KEY_SUCCESS,
    payload: request,
  };
}

export function getAdhocAlertPopUp(callback) {
  const url = `${ROOT_URL}/hradmin/adhoc-alert-pop-up`;
  return axios({
    method: "GET",
    url,
  })
    .then((response) => {
      // console.log("getAlertPopUp", response);
      callback(response, null);
      return {
        type: GET_ALERT_POP_UP_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getAlertPopUp", error);
      callback(null, error);
      return {
        type: GET_ALERT_POP_UP_ERROR,
        payload: error.message,
      };
    });
}

export function createAccount({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/hradmin/account/create`;
  // console.log("data: ", accessToken, data);
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("createAccount", response);
      callback(response, null);
      return {
        type: ADD_PARTNER_HR_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("createAccount", error);
      callback(null, error);
      return {
        type: ADD_PARTNER_HR_ERROR,
        payload: error.message,
      };
    });
}

export function getMhcInsightsURL({ accessToken }, callback) {
  const url = `${ROOT_URL}/hradmin/mhcinsights/generateURL${
    INSURER_PORTAL === "1" || INSURER_PORTAL === 1 ? "/1" : ""
  }`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getHradminMhcInsightsURL", response);
      return {
        type: GET_INSIGHTS_URL_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getHradminMhcInsightsURL", error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function validateDownloadClaimsDataPermission(data, callback) {
  // console.log("validateDownloadClaimsDataPermission: ", data)
  return {
    type: VALIDATE_DOWNLOAD_CLAIMS_DATA_PERMISSION,
    payload: data,
  };
}

export function validateViewAnalyticsPermission(data, callback) {
  // console.log("validateViewAnalyticsPermission: ", data)
  return {
    type: VALIDATE_VIEW_ANALYTICS_PERMISSION,
    payload: data,
  };
}

export function validateViewPreSignedELOGPermission(data, callback) {
  // console.log("validateViewPreSignedELOGPermission: ", data)
  return {
    type: VALIDATE_VIEW_PRE_SIGNED_ELOG_PERMISSION,
    payload: data,
  };
}

export function validateAddPartnerHRPermission(data, callback) {
  // console.log("validateAddPartnerHRPermission: ", data)
  return {
    type: VALIDATE_ADD_PARTNER_HR_PERMISSION,
    payload: data,
  };
}

export function validateViewHRPartnerAccountListPermission(data, callback) {
  // console.log("validateViewHRPartnerAccountListPermission: ", data)
  return {
    type: VALIDATE_VIEW_HR_PARTNER_ACCOUNT_LIST_PERMISSION,
    payload: data,
  };
}

export function validateViewAccountLogsPermission(data, callback) {
  // console.log("validateViewAccountLogsPermission: ", data)
  return {
    type: VALIDATE_VIEW_ACCOUNT_LOGS_PERMISSION,
    payload: data,
  };
}

export function resetHRClaimData(data, callback) {
  // console.log("validateViewAccountLogsPermission: ", data)
  return {
    type: RESET_HR_CLAIM_DATA,
    payload: null,
  };
}

export function getCompanyListByPolicyNo(data, accessToken, callback) {
  const url = `${ROOT_URL}/hradmin/broker/clients`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getCompanyListByPolicyNo: ", response);
      callback(response.data.clients, null);
      return {
        type: GET_COMPANY_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      callback(null, error);
      console.log("getCompanyListByPolicyNo: ", error);
    });
}

export function submitElog({ data, attachments, accessToken }, callback) {
  // setup form data;
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    let value = data[key];
    //use key and value here
    if (value) {
      // console.log(key, ' - ', value);
      formData.set(key, value);
    }
  });
  for (let i = 0; i < attachments.length; i++) {
    formData.append("documents", attachments[i]);
  }
  // const url = `${ROOT_ELOG_URL}/api/v1/web_portal/create_eLoG_files`;
  const url = `${ROOT_URL}/externalapi/submitElog`;
  // console.log(qs.stringify({
  //     ...data, documents: attachments
  // }));
  return axios({
    method: "POST",
    url,
    data: formData,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("submitElog", response);
      callback(response.data.data, null);
      return {
        type: SUBMIT_ELOG_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("submitElog", error);
      callback(null, error);
      return {
        type: SUBMIT_ELOG_ERROR,
        payload: error,
      };
    });
}

export function submitRequestResetPassword(data, callback) {
  const url = `${ROOT_URL}/hradmin/requestResetPassword`;
  return axios
    .post(url, {
      email: data.email,
    })
    .then((response) => {
      // console.log("submitRequestResetPassword", response);
      callback(response.status, null);
      return {
        type: SUBMIT_REQ_RESET_PASSWORD_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("submitRequestResetPassword", error);
      callback(null, error);
      return {
        type: SUBMIT_REQ_RESET_PASSWORD_ERROR,
        payload: error,
      };
    });
}

export function submitResetPassword(data, callback) {
  const encryptedPassword = encryptStringWithPublicKey(data.password);
  const url = `${ROOT_URL}/users/resetPassword`;
  return axios
    .post(url, {
      token: data.token,
      newPassword: encryptedPassword,
    })
    .then((response) => {
      // console.log("submitResetPassword", response);
      callback(response.data, null);
      return {
        type: SUBMIT_RESET_PASSWORD_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("submitResetPassword", error);
      callback(null, error);
      return {
        type: SUBMIT_RESET_PASSWORD_ERROR,
        payload: error,
      };
    });
}

export function submitCreatePassword(data, callback) {
  const encryptedPassword = encryptStringWithPublicKey(data.password);
  const url = `${ROOT_URL}/users/createPassword`;
  return axios
    .post(url, {
      uuid: data.uuid,
      newPassword: encryptedPassword,
    })
    .then((response) => {
      // console.log("submitCreatePassword", response);
      callback(response.status, null);
      return {
        type: SUBMIT_CREATE_PASSWORD_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("submitCreatePassword", error);
      callback(null, error);
      return {
        type: SUBMIT_CREATE_PASSWORD_ERROR,
        payload: error,
      };
    });
}

export function getClinicList(accessToken, callback) {
  const url = `${ROOT_URL}/hradmin/clinics`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getClinicList", response);
      return {
        type: GET_CLINIC_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getClinicList", error);
      return {
        type: GET_CLINIC_LIST_ERROR,
        payload: error,
      };
    });
}

export function getElogConfigQuestions(nric, accessToken, callback) {
  const url = `${ROOT_URL}/externalapi/getElogConfigQuestions`;
  return axios({
    method: "POST",
    url,
    data: { nric },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getElogConfigQuestions", response);
      return {
        type: GET_APP_CFG_ELOG_QUESTIONS_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getElogConfigQuestions", error);
      return {
        type: GET_APP_CFG_ELOG_QUESTIONS_ERROR,
        payload: error,
      };
    });
}

export function getClaimOptions(accessToken, selectStaff, callback) {
  const url = `${ROOT_URL}/config/hradmin/claimoptions/${selectStaff[0].uuid}`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getClaimOptions: ", response);
      return {
        type: GET_CLAIM_OPTIONS_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getClaimOptions: ", error);
      return {
        type: GET_CLAIM_OPTIONS_ERROR,
        payload: error.message,
      };
    });
}

export function doLogout() {
  return {
    type: "USER_LOGOUT",
    payload: null,
  };
}

// export function doLogin({ email, password, birthdate, isBroker }, callback) {
//   const encryptedPassword = encryptStringWithPublicKey(password);
//   let url = "";
//   let param = null;

//   if (isBroker) {
//     // url = `${ROOT_URL}/users/login`;
//     url = `${ROOT_URL}/users/login/v2`;
//     param = {
//       email,
//       password: encryptedPassword,
//       birthdate,
//       isBroker,
//     };
//   } else {
//     url = `${ROOT_URL}/users/login/v2`;
//     param = {
//       email,
//       password: encryptedPassword,
//       birthdate,
//     };
//   }

//   return axios
//     .post(url, param)
//     .then((response) => {
//       callback(response.status, null);
//       return {
//         type: isBroker ? DO_LOGIN_BROKER_SUCCESS : DO_LOGIN_HR_SUCCESS,
//         payload: response,
//       };
//     })
//     .catch((error) => {
//       // console.log("doLogin: ", error);
//       callback(null, error);
//       return {
//         type: DO_LOGIN_ERROR,
//         payload: error,
//       };
//     });
// }

export function doReloginV3({ email, password, isBroker }, callback) {
  // const encryptedNric = encryptStringWithPublicKey(nric);
  const encryptedPassword = encryptStringWithPublicKey(password);

  const url = `${ROOT_URL}/users/login/v3`;
  return axios
    .post(url, {
      email,
      password: encryptedPassword,
      isBroker,
      enableOTP: ENABLE_OTP === "1" ? true : false,
      insurerPortal:
        INSURER_PORTAL === "1" || INSURER_PORTAL === 1 ? true : false,
      masterAdmin: permission.PERMISSION_MASTER_ADMIN,
    })
    .then((response) => {
      // console.log("doReloginV3: ", response);
      callback(response.data.user, null);
      return {
        type: isBroker ? DO_RELOGIN_BROKER_SUCCESS : DO_RELOGIN_HR_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("doReloginV3: ", error);
      callback(null, error);
      return {
        type: DO_RELOGIN_ERROR,
        payload: error,
      };
    });
}

export function doLoginV3({ email, password, isBroker }, callback) {
  // const encryptedNric = encryptStringWithPublicKey(nric);
  const encryptedPassword = encryptStringWithPublicKey(password);

  // console.log("[INSURER_PORTAL]", INSURER_PORTAL);
  // console.log("[doLoginV3 - INSURER_PORTAL]", INSURER_PORTAL === "1" || INSURER_PORTAL === 1 ? true : false);

  const url = `${ROOT_URL}/users/login/v3`;
  return axios
    .post(url, {
      email,
      password: encryptedPassword,
      isBroker,
      enableOTP: ENABLE_OTP === "1" ? true : false,
      insurerPortal:
        INSURER_PORTAL === "1" || INSURER_PORTAL === 1 ? true : false,
      masterAdmin: permission.PERMISSION_MASTER_ADMIN,
      isHRAdminPortal: true,
    })
    .then((response) => {
      // console.log("doLoginV3: ", response);
      callback(response.data.user, null);
      return {
        type: isBroker ? DO_LOGIN_BROKER_SUCCESS : DO_LOGIN_HR_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("doLoginV3: ", error);
      callback(null, error);
      return {
        type: DO_LOGIN_ERROR,
        payload: error,
      };
    });
}

export function generateLoginOTPEmail(data, callback) {
  let encryptedIdentifier = "";

  if (data.isBroker) {
    encryptedIdentifier = encryptStringWithPublicKey(data.email);
  } else {
    encryptedIdentifier = encryptStringWithPublicKey(data.nric);
  }

  const url = `${ROOT_URL}/users/hradmin/generateLoginOTPEmailCode`;
  return axios
    .post(url, {
      identifier: encryptedIdentifier,
      isBroker: data.isBroker,
    })
    .then((response) => {
      // console.log("generateLoginOTPEmailCode", response);
      callback(response, null);
      return {
        type: GENERATE_LOGIN_EMAIL_OTP_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("generateLoginOTPEmailCode", error);
      callback(null, error);
      return {
        type: GENERATE_LOGIN_EMAIL_OTP_ERROR,
        payload: error,
      };
    });
}

export function verifyLoginOTPEmail(data, callback) {
  let encryptedIdentifier = "";

  if (data.isBroker) {
    encryptedIdentifier = encryptStringWithPublicKey(data.email);
  } else {
    encryptedIdentifier = encryptStringWithPublicKey(data.nric);
  }

  const url = `${ROOT_URL}/users/verifyLoginOTPEmailCode`;
  return axios
    .post(url, {
      identifier: encryptedIdentifier,
      otp: data.otp,
      isBroker: data.isBroker,
    })
    .then((response) => {
      //  console.log('verifyLoginOTPEmailCode', response);
      callback(response.data, null);
      return {
        type: VERIFY_LOGIN_EMAIL_OTP_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("verifyLoginOTPEmailCode", error);
      callback(null, error);
      return {
        type: VERIFY_LOGIN_EMAIL_OTP_ERROR,
        payload: error,
      };
    });
}

export const checkIfTokenHasExpired = (errorCode) => {
  if (errorCode && errorCode === 401) {
    return true;
  }
  return false;
};

export function verifyAccessTokenExpiry(accessToken, callback) {
  const url = `${ROOT_URL}/hradmin/verifyaccesstoken`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("verifyaccesstoken", response);
      callback(response.data, null);
      return {
        type: VERIFY_LOGIN_EMAIL_OTP_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("verifyaccesstoken", error);
      const isTokenExpired = checkIfTokenHasExpired(error.errorCode);
      if (isTokenExpired) {
        return {
          type: UPDATE_USER_TOKEN_EXPIRED_ERROR,
          payload: error,
        };
      }
      return {
        type: VERIFY_LOGIN_EMAIL_OTP_ERROR,
        payload: error,
      };
    });
}

export function loginSuccess(data) {
  return {
    type: data.user.isBroker ? LOGIN_BROKER_SUCCESS : LOGIN_HR_SUCCESS,
    payload: data,
  };
}

export function reloginSuccess(data) {
  return {
    type: data.user.isBroker ? RE_LOGIN_BROKER_SUCCESS : RE_LOGIN_HR_SUCCESS,
    payload: data,
  };
}

export function getHrClaimList({ accessToken, claimantId }, callback) {
  const url = `${ROOT_URL}/hradmin/hrclaims${
    claimantId ? "/" + claimantId : ""
  }`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getHrClaimList: ", response);

      return {
        type: GET_ALL_EMPLOYEE_CLAIMS_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getHrClaimList: ", error);

      return {
        type: GET_ALL_EMPLOYEE_CLAIMS_LIST_FAIL,
        payload: error,
      };
    });
}

export function getHRPolicyNoByCompanyId(data, accessToken) {
  const url = `${ROOT_URL}/hradmin/hr/client`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getHRPolicyNoByCompanyId: ", response);
      return {
        type: GET_HR_POLICY_NO_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getHRPolicyNoByCompanyId: ", error);
      return {
        type: GET_HR_POLICY_NO_FAIL,
        payload: [],
      };
    });
}

export function getCompanyByPolicyNo(data, accessToken) {
  const url = `${ROOT_URL}/hradmin/hr/client/policyNo`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getCompanyByPolicyNo: ", response);
      return {
        type: GET_COMPANY_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getCompanyByPolicyNo: ", error);
      return {
        type: GET_COMPANY_FAIL,
        payload: [],
      };
    });
}

export function getHRCompanyByPolicyNo(data, accessToken) {
  const url = `${ROOT_URL}/hradmin/hr/client/policyNo`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getHRCompanyByPolicyNo: ", response);
      return {
        type: GET_BROKER_SINGLE_HR_COMPANY_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getHRCompanyByPolicyNo: ", error);
      return {
        type: GET_BROKER_SINGLE_HR_COMPANY_FAIL,
        payload: [],
      };
    });
}

export function updateBrokerSelectedPolicyNo(data, callback) {
  return {
    type: UPDATE_BROKER_SELECTED_POLICY_NO,
    payload: {
      policyNo: data.policyNo,
    },
  };
}

export function updateAccount(data, accessToken) {
  const url = `${ROOT_URL}/hradmin/account/update`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("updateAccount: ", response);
      return {
        type: UPDATE_ACCOUNT_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("updateAccount: ", error);
    });
}

export function updateBrokerSelectedCompany(data, accessToken) {
  const url = `${ROOT_URL}/hradmin/broker/company`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("updateBrokerSelectedCompany: ", response);
      return {
        type: UPDATE_BROKER_SELECTED_COMPANY_SUCCESS,
        payload: response,
        allowOutpatient: data.allowOutpatient,
        allowInpatient: data.allowInpatient,
      };
    })
    .catch((error) => {
      // console.log("updateBrokerSelectedCompany: ", error);
    });
}

export function getUsers(accessToken) {
  const url = `${ROOT_URL}/users`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getUsers: ", response);
      return {
        type: GET_USERS_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getUsers: ", error);
      return {
        type: GET_USERS_FAIL,
        payload: null,
      };
    });
}

export function approveRejectElog(
  { accessToken, eLogId, action, actionBy, actionRole, remarks },
  callback
) {
  const url = `${ROOT_URL}/hradmin/elog/validate`;
  return axios({
    method: "POST",
    url,
    data: { eLoG_id: eLogId, action, actionBy, actionRole, remarks },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("approveRejectElog: ", response);
      callback(response, null);
      return {
        type: APPROVE_REJECT_ELOG_SUCCESS,
        payload: {
          response,
        },
      };
    })
    .catch((error) => {
      // console.log("approveRejectElog: ", error);
      callback(null, error);
    });
}

export function getFileURL(accessToken, filename, policyNo, eLogId) {
  const url = `${ROOT_URL}/hradmin/elog/get-file-url`;
  // const url = `${LOG_ACCESS_ROOT_URL}/api/v1/web_portal/generate_PDF_URL`;

  return axios({
    method: "POST",
    url,
    data: { filename, policyNo, eLoG_ID: eLogId },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getFileURL: ", response);

      return {
        type: GET_FILES_URL_SUCCESS,
        payload: {
          response,
        },
      };
    })
    .catch((error) => {
      // console.log("getFileURL: ", error);
    });
}

export function submitPreSignedElog({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/hradmin/elog/pre-signed`;
  // const url = `${LOG_ACCESS_ROOT_URL}/api/v1/web_portal/elog/pre-signed`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("submitPreSignedElog: ", response);
      callback(response, null);
      return {
        type: SUBMIT_PRE_SIGNED_ELOG_SUCCESS,
        payload: {
          response,
        },
      };
    })
    .catch((error) => {
      console.log("submitPreSignedElog error: ", error);
      callback(null, error);
      return {
        type: SUBMIT_PRE_SIGNED_ELOG_LIST_FAIL,
        payload: [],
      };
    });
}

export function getPreSignedElogList({ accessToken, policy_no }, callback) {
  const url = `${ROOT_URL}/hradmin/elog/pre-signed/list`;
  // const url = `${LOG_ACCESS_ROOT_URL}/api/v1/web_portal/pre-signed/listsByPolicy`;
  return axios({
    method: "POST",
    url,
    data: { policy_no },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getPreSignedElogList: ", response);
      return {
        type: GET_PRE_SIGNED_ELOG_LIST_SUCCESS,
        payload: {
          response,
        },
      };
    })
    .catch((error) => {
      console.log("getPreSignedElogList: ", error);
      return {
        type: GET_PRE_SIGNED_ELOG_LIST_FAIL,
        payload: [],
      };
    });
}

export function getElogList({ accessToken, policyNo }, callback) {
  const url = `${ROOT_URL}/hradmin/elog/list`;
  return axios({
    method: "POST",
    url,
    data: { policyNo },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      let eLogCount = 0;
      // console.log("getElogList: ", response);
      if (response.data.results.length > 0) {
        for (let i = 0; i < response.data.results.length; i++) {
          if (response.data.results[i].status === "Pending HR verification") {
            eLogCount++;
          }
        }
      }

      return {
        type: GET_ELOG_LIST_SUCCESS,
        payload: {
          response,
          pendingHRElogCount: eLogCount,
        },
      };
    })
    .catch((error) => {
      console.log("getElogList: ", error);
      return {
        type: GET_ELOG_LIST_FAIL,
        payload: [],
      };
    });
}

export function exportEmployeeListData(accessToken, callback) {
  const url = `${ROOT_URL}/hradmin/export/employees`;
  return axios({
    method: "GET",
    url,
    responseType: "blob",
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("exportEmployeeListData", response);
      callback(response, null);
      return {
        type: GET_EXPORT_EMPLOYEE_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("exportEmployeeListData", error);
      callback(null, error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getBrokerListData(accessToken, callback) {
  const url = `${ROOT_URL}/hradmin/brokers`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getBrokerListData", response);
      return {
        type: GET_BROKER_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getBrokerListData", error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getEmployeeListDataByPolicy(
  { policyId, accessToken },
  callback
) {
  const url = `${ROOT_URL}/hradmin/employees/policyId/${policyId}`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("getEmployeeListDataByPolicy", response);
      return {
        type: GET_EMPLOYEE_LIST_BY_POLICY_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getEmployeeListDataByPolicy", error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getEmployeeListData({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/hradmin/employees`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getEmployeeListData", response);
      return {
        type: GET_EMPLOYEE_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("getEmployeeListData", error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getLazyEmployeeClaimsListData(
  { accessToken, employees },
  callback
) {
  const url = `${ROOT_URL}/hradmin/employees/claimList`;
  return axios({
    method: "POST",
    url,
    data: {
      employees,
    },
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getLazyEmployeeClaimsListData", response);
      return {
        type: GET_LAZY_EMPLOYEE_CLAIM_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getLazyEmployeeClaimsListData", error);
      return {
        type: GET_LAZY_EMPLOYEE_CLAIM_LIST_FAIL,
        payload: error.message,
      };
    });
}

export function submitContactUs({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/hradmin/employee/contactus`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("submitContactUs", response);
      return {
        type: SUBMIT_CONTACT_US_SUCCESS,
        payload: {
          response,
          selectedUserId: response,
        },
      };
    })
    .catch((error) => {
      // console.log("submitContactUs", error);
      return {
        type: SUBMIT_CONTACT_US_FAIL,
        payload: {
          error,
        },
      };
    });
}

export function getEmployeeClaimsListData(
  { userId, accessToken, isBroker },
  callback
) {
  const url = `${ROOT_URL}/hradmin/employee/${userId}/claimList`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getEmployeeClaimsListData", response);
      return {
        type: GET_EMPLOYEE_CLAIMS_LIST_SUCCESS,
        payload: {
          response,
          selectedUserId: userId,
        },
      };
    })
    .catch((error) => {
      // console.log("getEmployeeClaimsListData", error);
      return {
        type: GET_EMPLOYEE_CLAIMS_LIST_FAIL,
        payload: {
          error,
        },
      };
    });
}

export function getEmployeeOutpatientClaimData(
  { transactionNo, userId, accessToken, isBroker },
  callback
) {
  const url = `${ROOT_URL}/hradmin/employee/${userId}/claim/out/${transactionNo}`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getEmployeeOutpatientClaimData", response);
      callback(response, null);
      return {
        type: GET_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS,
        payload: {
          response,
          selectedUserId: userId,
          selectedClaimToView: transactionNo,
        },
      };
    })
    .catch((error) => {
      // console.log("getEmployeeOutpatientClaimData", error);
      callback(null, error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getEmployeeInpatientClaimData(
  { transactionNo, userId, accessToken, isBroker },
  callback
) {
  const url = `${ROOT_URL}/hradmin/employee/${userId}/claim/inp/${transactionNo}`;
  return axios({
    method: "GET",
    url,
    data: {},
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getEmployeeInpatientClaimData", response);
      callback(response, null);
      return {
        type: GET_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS,
        payload: {
          response,
          selectedUserId: userId,
          selectedClaimToView: transactionNo,
        },
      };
    })
    .catch((error) => {
      // console.log("getEmployeeInpatientClaimData", error);
      callback(null, error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getEmployeePanelVisitClaimData(
  { visitNo, userId, claim },
  callback
) {
  return {
    type: GET_EMPLOYEE_PANEL_VISIT_CLAIM_DATA_SUCCESS,
    payload: {
      response: claim,
      selectedUserId: userId,
      selectedClaimToView: visitNo,
    },
  };
}

export function submitEmployeeHrClaimData(
  { data, attachments, userId, accessToken, isBroker },
  callback
) {
  // setup form data;
  let formData = new FormData();

  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (value !== undefined) {
      formData.append(key, value);
    }
  });

  for (let i = 0; i < attachments.length; i++) {
    formData.append("attachment", attachments[i]);
  }

  // const url = `${ROOT_URL}/hradmin/employee/${userId}/claim`;

  const url = `${ROOT_URL}/hradmin/employee/${userId}/${
    data.typeOfClaim === "Outpatient Claim"
      ? "outpatientclaim"
      : "inpatientclaim"
  }`;

  return axios({
    method: "POST",
    url,
    data: formData,
    headers: {
      Accesstoken: accessToken,
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      // console.log("submitEmployeeHrClaimData", response);
      callback(response, null);
      return {
        type: SUBMIT_EMPLOYEE_HR_CLAIM_DATA_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("submitEmployeeHrClaimData", error);
      console.log("submitEmployeeHrClaimData: ", error);
      callback(null, error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function submitEmployeeUpdateAccess(
  { data, userId, accessToken, isBroker },
  callback
) {
  const url = `${ROOT_URL}/hradmin/employee/${userId}/access`;

  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("submitEmployeeUpdateAccess", response);
      callback(response, null);
      return {
        type: SUBMIT_EMPLOYEE_UPDATE_ACCESS_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("submitEmployeeUpdateAccess", error);
      callback(null, error);
      return {
        type: UPDATE_API_ERROR,
        payload: error.message,
      };
    });
}

export function getPreSignedElogConfig({ accessToken }, callback) {
  const url = `${ROOT_URL}/hradmin/pre-signed-elog/config`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("getPreSignedElogConfig", response);
      callback(response);
      return {
        type: GET_PRE_SIGNED_ELOG_CONFIG_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("getPreSignedElogConfig error", error);
      return {
        type: GET_PRE_SIGNED_ELOG_CONFIG_FAIL,
        payload: error.message,
      };
    });
}

export function sendPreSignedElogNotificationEmail(
  { accessToken, data },
  callback
) {
  const url = `${ROOT_URL}/hradmin/pre-signed-elog/email-notification`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("sendPreSignedElogNotificationEmail", response);
      return {
        type: POST_PRE_SIGNED_ELOG_EMAIL_NOTIFICATION_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("sendPreSignedElogNotificationEmail error", error);
      return {
        type: POST_PRE_SIGNED_ELOG_EMAIL_NOTIFICATION_FAIL,
        payload: error.message,
      };
    });
}

// export function minsightDownloadReportBackend(data, accessToken) {
//    // console.log("minsightDownloadReport data: ", data);
//    const url = `${ROOT_URL}/hradmin/download/claim-report`;

//    return axios({
//       method: "POST",
//       url,
//       data,
//       responseType: 'blob',
//       headers: {
//          'Content-Type': 'application/json',
//          Accesstoken: accessToken
//       }
//    })
//       .then(response => {
//          console.log("1: ", response.data);
//          // const url = window.URL.createObjectURL(new Blob([response.data]));
//          const url = window.URL.createObjectURL(response.data);
//          const link = document.createElement('a');
//          link.href = url;
//          link.setAttribute('download', 'report.zip');
//          document.body.appendChild(link);
//          link.click();
//          return {
//             type: GET_MINSIGHT_CLAIM_REPORT_SUCCESS,
//             payload: response
//          };
//       })
//       .catch(error => {
//          console.log("minsightDownloadReport error", error);
//          return {
//             type: GET_MINSIGHT_CLAIM_REPORT_FAIL,
//             payload: error.message
//          };
//       });
// }

export function minsightDownloadReport(data, callback) {
  let url = `${MINSIGHT_URL}/api/public_api/Download_Claim_Report`;

  if (INSURER_PORTAL === "1" || INSURER_PORTAL === 1 ? true : false) {
    url = `${MINSIGHT_URL}/api/public_api/Download_Claim_Report_Insurer`;
  }

  return axios({
    method: "POST",
    responseType: "blob",
    url,
    data,
    headers: {
      "Content-Type": "application/json",
      AuthToken: JSON.stringify({
        access_name: "MInsights_Public_API",
        access_token: "SSba7a5Hu3bNFnW55EAE",
      }),
    },
  })
    .then((response) => {
      // console.log("minsightDownloadReport", response)
      callback(response, null);
      return {
        type: GET_MINSIGHT_CLAIM_REPORT_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("minsightDownloadReport", error);
      return {
        type: GET_MINSIGHT_CLAIM_REPORT_FAIL,
        payload: error.message,
      };
    });
}

export function updateInpatientClaim(
  { data, attachments, oldAttachments, accessToken, transactionNo, delete_attachments },
  callback
) {
  // setup form data;
  let companyIdQuery = `?companyId=${data.companyId}`;
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (value) {
      formData.append(key, value);
    }
  });
  for (let i = 0; i < attachments.length; i++) {
    formData.append("attachment", attachments[i]);
  }
  formData.append("oldAttachment", JSON.stringify(oldAttachments));
  formData.append("delete_attachments", JSON.stringify(delete_attachments));
  // send formData to API
  const url = `${ROOT_URL}/hradmin/inpatientclaim/${transactionNo}${companyIdQuery}`;
  return axios({
    method: "PUT",
    url,
    data: formData,
    headers: {
      Accesstoken: accessToken,
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      console.log("updateInpatientClaim", response);
      callback(response.data.inpatientclaims, null);
      return {
        type: UPDATE_INPATIENT_CLAIM_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("updateInpatientClaim", error);
      callback(null, error);
      return {
        type: UPDATE_INPATIENT_CLAIM_ERROR,
        payload: error,
      };
    });
}

export function updateOutpatientClaim(
  { data, attachments, accessToken, nric, oldAttachments, transactionNo, delete_attachments },
  callback
) {
  let companyIdQuery = `?companyId=${data.companyId}`;
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (value) {
      formData.append(key, value);
    }
  });

  formData.append("oldAttachment", JSON.stringify(oldAttachments));
  formData.append("delete_attachments", JSON.stringify(delete_attachments));
  for (let i = 0; i < attachments.length; i++) {
    formData.append("attachment", attachments[i]);
  }

  const encryptedNric = encryptStringWithPublicKey(nric);
  const encryptText = encodeURIComponent(encryptedNric);
  // console.log('encryptText', encryptText);
  const url_1 = `${ROOT_URL}/hradmin/outpatientclaim/${encryptText}/${transactionNo}${companyIdQuery}`;
  const url = encodeURI(url_1);
  console.log("url-updateOutpatientClaim", url);
  return axios({
    method: "PUT",
    url,
    data: formData,
    headers: {
      Accesstoken: accessToken,
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      console.log("updateOutpatientClaim", response);
      callback(response.data, null);
      return {
        type: UPDATE_OUTPATIENT_CLAIM_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      console.log("updateOutpatientClaim", error);
      callback(null, error);
      return {
        type: UPDATE_OUTPATIENT_CLAIM_ERROR,
        payload: error,
      };
    });
}

export function triggerMemberResetPasswordEmail({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/users/requestResetPassword`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      console.log("triggerMemberResetPasswordEmail", response);
      callback(response, null);
      return {
        type: TRIGGER_RESET_PASSWORD_EMAIL_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("triggerMemberResetPasswordEmail", error);
      callback(null, error);
      return {
        type: TRIGGER_RESET_PASSWORD_EMAIL_FAIL,
        payload: {
          error,
        },
      };
    });
}

export function triggerResetPasswordEmail({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/hradmin/trigger-reset-password-email`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("triggerResetPasswordEmail", response);
      callback(response, null);
      return {
        type: TRIGGER_RESET_PASSWORD_EMAIL_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("triggerResetPasswordEmail", error);
      callback(null, error);
      return {
        type: TRIGGER_RESET_PASSWORD_EMAIL_FAIL,
        payload: {
          error,
        },
      };
    });
}

export function triggerOnboardingEmail({ accessToken, data }, callback) {
  const url = `${ROOT_URL}/hradmin/trigger-onboarding-email`;
  return axios({
    method: "POST",
    url,
    data,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      // console.log("triggerOnboardingEmail", response);
      callback(response, null);
      return {
        type: TRIGGER_ONBOARDING_EMAIL_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      // console.log("triggerOnboardingEmail", error);
      callback(null, error);
      return {
        type: TRIGGER_ONBOARDING_EMAIL_FAIL,
        payload: {
          error,
        },
      };
    });
}

export function get_bank_list(accessToken, callback) {
  const url = `${ROOT_URL}/hradmin//bank-list`;
  return axios({
    method: "GET",
    url,
    headers: { Accesstoken: accessToken },
  })
    .then((response) => {
      if (callback) {
        callback(response, null);
      }

      return {
        type: GET_BANK_LIST_SUCCESS,
        payload: response,
      };
    })
    .catch((error) => {
      if (callback) {
        callback(null, error);
      }

      return {
        type: GET_BANK_LIST_FAILED,
        payload: {
          error,
        },
      };
    });
}
